import type { FxCash } from '@/store/cash/state.ts';
import type { AppState } from '@/store/store.ts';

export const selectCashTile = (state: AppState, tileId: string) => {
  return state.cash[tileId] as FxCash | undefined;
};
